const newEquipment = {
  plant: "Facility",
  equipment: "Create a new Asset",
  backbtn: "Go Back",
  modulesButton: "Modules",
  equipmentTag: "Asset Tag",
  mechanical: "Cooling Lubricant Code",
  customer: "Customer",
  equipmentType: "Asset Type",
  typeContract: "Type of Contract",
  statuslights: {
    running: "Running",
    standby: "Standby",
    maintenance: "Maintenance",
    failure: "Failure"
  },
  tabs: {
    info: "BASIC INFO",
    values: "OPERATIONAL VALUES",
    ranges: "VARIABLE RANGES"
  },
  equipmentStatus: "Mechanical condition of the asset",
  area: "Area",
  location: "Select Location",
  selectPlant: "Select Facility",
  selectArea: "Select Area",
  selectUnit: "Select Unit",
  unit: "Unit",
  sealTypes: "Mechanical Seal Types",
  hazardous: "Hazardous Area Classification",
  createdBy: "Created By",
  dateCreated: "Date Created",
  comment: "Comment",
  pumpHousing: "Pump Housing",
  deleteEquipment: "Delete Asset",
  snackText: "Your new asset has been created",
  submit: "Submit",
  picture: "Image",
  machineHealthIndex: "Machine Health Index",
  mechanicalCondition: "Asset operating condition",

  manufacturer: "Manufacturer"
};
export default newEquipment;
